import Link from 'next/link'
import React, { useEffect } from 'react'
import styled from 'styled-components'
import {
  getAllItemList_itemModule_itemList_edges_node,
  getItemListByCategory_marketingModule_itemList_itemList_edges_node,
} from '~/graphqls/types'
import { ActivityTypeEnum } from '~/graphqls/types/gqls.global'
import { FenToYuan } from '~/utils'
import { MyImage } from '../ui/MyImage'
import styles from './MallItem.module.css'
import classNames from 'classnames'

const StyledMallItem = styled.div`
  margin-bottom: 32px;
  .item-thumb-wrap {
    position: relative;
    height: 352px;
    margin-bottom: 12px;
    border-radius: 30px;
    overflow: hidden;
    display: block;
    &:hover {
      .item-thumb {
        transform: scale(1.02);
        transition: all ease-in-out 180ms;
      }
    }
  }
  .item-thumb {
    height: 100%;
    width: 100%;
    transition: all ease-in-out 180ms;
  }
  .item-title {
    font-size: 20px;
    line-height: 28px;
    height: 56px;
    margin-bottom: 8px;
    word-break: break-all;
    display: -webkit-box;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 2;
    /*! autoprefixer: ignore next */
    -webkit-box-orient: vertical;
  }
  .item-price {
    font-size: 24px;
    line-height: 32px;
    color: ${props => props.theme.errorColor};
  }
`

export const MallItem: React.FC<{
  data:
    | getItemListByCategory_marketingModule_itemList_itemList_edges_node
    | getAllItemList_itemModule_itemList_edges_node
}> = ({ data }) => {
  const isLimitDiscount =
    data?.activityTheme?.activityType === ActivityTypeEnum.DISCOUNT
  return (
    <StyledMallItem>
      <Link href={`/mall/item/${data.id}`}>
        <a className="item-thumb-wrap">
          <MyImage
            tag="v800"
            className="item-thumb"
            src={data?.imageList?.[0]}
          />
          <div className={styles.tagsWrap}>
            {data?.activityTheme?.tagName &&
              data?.activityTheme?.activityType ===
                ActivityTypeEnum.DISCOUNT && (
                <div className={styles.discountTag}>
                  {data?.activityTheme?.tagName}
                </div>
              )}
            {data?.activityTheme?.id &&
              data?.activityTheme?.activityType ===
                ActivityTypeEnum.FULL_REDUCTION && (
                <div
                  className={classNames(
                    'text-base text-neutral-200 font-semibold rounded-3xl !leading-none px-2 py-3 bg-gradient-to-r from-[#FFEBD8] to-[#FFE1A8]',
                    styles.activityTag
                  )}
                >
                  {data?.activityTheme?.tagName}
                </div>
              )}
          </div>
        </a>
      </Link>
      <Link href={`/mall/item/${data.id}`}>
        <a>
          <div className="item-title">{data.name}</div>
        </a>
      </Link>
      {isLimitDiscount ? (
        <div className="item-price">
          <span>¥{FenToYuan(data.activityPrice || data.price)}</span>
          <span className="font-light"> 折后价</span>
        </div>
      ) : (
        <div className="item-price">¥{FenToYuan(data.price)}</div>
      )}
    </StyledMallItem>
  )
}
